module.exports = __webpack_public_path__ + "static/media/no_image_user_kid_1.8f277c4d.png";